import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

const GroupCardSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View
      style={{ opacity }}
      className="flex-1 bg-chalk rounded-2xl overflow-hidden md:border md:border-ash-3 p-2 gap-2"
    >
      {/* Cover image */}
      <View className="w-full h-[120px] rounded-xl bg-ash-3" />

      {/* Body */}
      <View className="flex-1 flex-col gap-2 px-1 pb-1">
        <View className="gap-2">
          {/* Title */}
          <View className="h-4 w-3/4 rounded-md bg-ash-3" />
          {/* Description line */}
          <View className="h-3 w-full rounded-md bg-ash-3" />

          {/* Meta row */}
          <View className="flex-row items-center gap-2 mt-1">
            {/* Privacy pill */}
            <View className="h-5 w-20 rounded-full bg-ash-3" />
            <View className="h-3 w-16 rounded-md bg-ash-3" />
          </View>
        </View>

        {/* Button bar */}
        <View className="h-9 w-full rounded-xl bg-ash-3 mt-auto" />
      </View>
    </Animated.View>
  );
};

export default GroupCardSkeleton;
